import { createSelector } from '@reduxjs/toolkit';
import { selectDevices } from 'entities/device/lib';
import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { getDeviceError, getDeviceInfo } from 'console/device/device_ts';
import { billedSimsWithProblems } from 'console/sim/utils/sim-problem';
import { get_account_balance_x100, isAutoPaymentEnabled, } from 'console/billing/billing-utils';
import { select_ui_settings, set_ui_settings, } from 'console/redux/settings-actions';
export const select_devices_with_stationary_location = createSelector(selectDevices, (devices) => Object.fromEntries(devices
    .filter((dev) => !LegacyDevice.has_capability(dev?.capabilities, Capability.has_gps))
    .map((dev) => [
    dev.id,
    {
        location: dev.stationary_location != null
            ? dev.stationary_location.loc
            : null,
        ...getDeviceInfo(dev),
    },
])));
export const select_devices_with_locations = createSelector(selectDevices, (devices) => {
    return Object.fromEntries(devices
        .filter((dev) => LegacyDevice.has_capability(dev?.capabilities, Capability.has_gps))
        .map((dev) => [
        dev.id,
        {
            locations: dev.last_gps?.map((last_gps) => [last_gps.x, last_gps.y] ?? null),
            color: dev.color ?? '#c4443b',
            ...getDeviceInfo(dev),
        },
    ]));
});
export const select_device_errors = createSelector(selectDevices, billedSimsWithProblems, isAutoPaymentEnabled, get_account_balance_x100, (devices, billed_sims, autopayment_enabled, balance_x100) => {
    return Object.fromEntries(devices.map((dev) => [
        dev.id,
        getDeviceError(dev, billed_sims, autopayment_enabled, balance_x100),
    ]));
});
export const getSnackbarTooltip = (state) => select_ui_settings(state).map?.show_snackbar_tooltip ?? true;
export const hideSnackbarTooltip = () => (dispatch) => {
    dispatch(set_ui_settings({ map: { show_snackbar_tooltip: false } }));
};
